import React, { FC } from 'react'
import { Box, Breadcrumbs as MUIBreadcrumbs, styled, SxProps, Theme, Typography, TypographyProps } from '@mui/material'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'

export interface IBreadcrumbConfig {
  label: string
  url?: string
  props?: TypographyProps & { [key: string]: any }
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}

export interface IBreadcrumbsProps {
  value?: IBreadcrumbConfig[]
  sx?: SxProps<Theme>
}

export const Breadcrumbs: FC<IBreadcrumbsProps> = (props) => {
  const list = props.value ?? []

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, x: IBreadcrumbConfig) => {
    e.preventDefault()
    e.stopPropagation()
    x.onClick && x.onClick(e)
  }

  const getItemProps = (item: IBreadcrumbConfig): TypographyProps => {
    return item.props ?? (item.url ? ({ component: 'a', href: item.url } as TypographyProps) : {})
  }

  return (
    <MUIBreadcrumbs sx={props.sx}>
      {list.map((x, i) => {
        const isClick = !!x.onClick || !!x.url
        return (
          <WrapTypography
            key={'key' + i}
            {...getItemProps(x)}
            onClick={x.onClick ? (e: any) => handleClick(e, x) : undefined}
            className={isClick ? 'clickable' : ''}
          >
            {i < 1 && <ArrowBackIosIcon fontSize='small' />}
            <Typography variant='subtitle1' noWrap>
              <span>{x.label}</span>
            </Typography>
          </WrapTypography>
        )
      })}
    </MUIBreadcrumbs>
  )
}
export default Breadcrumbs

const WrapTypography = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: `var(--color-title, ${theme.palette.text.primary})`,
  '.MuiTypography-root': {
    color: 'currentColor',
    fontWeight: 600
  },
  '.MuiSvgIcon-root': {
    color: 'currentColor',
    fontSize: theme.typography.pxToRem(16),
    marginRight: theme.spacing(0.5)
  },
  '&[href]': {
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
      color: `var(--color-title-hover, ${theme.palette.primary.main})`
    }
  }
}))
